import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { useBusinessAccounts } from '@/hooks/useBusinessAccounts';

export const FIRST_RUN_FALLBACK_PATH = '/home';

export type FirstRunRouteAccess = 'pending' | 'allow' | 'block';

export function resolveFirstRunRouteAccess({
  accounts,
  isLoading,
}: {
  accounts: unknown;
  isLoading: boolean;
}): FirstRunRouteAccess {
  if (isLoading) return 'pending';
  if (!Array.isArray(accounts)) return 'allow';
  return accounts.length > 0 ? 'block' : 'allow';
}

export function OnboardingFirstRunGuard({ children }: { children: React.ReactNode }) {
  const { data: accounts, isLoading, isPending } = useBusinessAccounts();
  const [verdict, setVerdict] = React.useState<FirstRunRouteAccess>('pending');

  React.useEffect(() => {
    if (verdict !== 'pending') return;
    const next = resolveFirstRunRouteAccess({
      accounts,
      isLoading: Boolean(isPending) || isLoading,
    });
    if (next !== 'pending') setVerdict(next);
  }, [accounts, isLoading, isPending, verdict]);

  if (verdict === 'pending') return null;

  if (verdict === 'block') {
    return <Navigate to={FIRST_RUN_FALLBACK_PATH} replace />;
  }

  return <>{children}</>;
}
